/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Typography from "@mui/material/Typography";
import { Box, Theme } from "@mui/material";
import highlightBoxStyle from "./highlightBoxStyle";
import { SxProps } from "@mui/system";

type HighlightBoxProps = {
  children: React.ReactNode;
  headline?: string;
  borderColor?: "primaryBorder" | "defaultBorder";
  textColor?: "primaryText" | "defaultText";
  textAlign?: "center" | "left" | "right";
  sx?: SxProps<Theme>;
};

const HighlightBox = ({
  children,
  headline = "",
  borderColor = "primaryBorder",
  textColor = "primaryText",
  textAlign = "left",
  sx = {},
}: HighlightBoxProps) => {
  return (
    <Box sx={{ ...highlightBoxStyle.box, ...highlightBoxStyle[borderColor], ...sx }}>
      {headline && (
        <Typography variant={"h3"} sx={highlightBoxStyle.headline}>
          {headline}
        </Typography>
      )}
      <Box sx={{ ...highlightBoxStyle[textColor], ...highlightBoxStyle[textAlign] }}>{children}</Box>
    </Box>
  );
};

export default HighlightBox;
